import m from "../../../../geodata/es2015/region/usa/laHigh";
window.am4geodata_region_usa_laHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/laHigh.js
// module id = null
// module chunks = 